import * as types from '../../constants/index'

export default {
  state: {
    clearscreen: false, // 课件清屏状态
    pptSize: {
      width: 0,
      height: 0,
      top: 0,
      left: 0,
      parentWidth: 0
    }
  },

  mutations: {
    [types.CLEAR_SCREEN] (state, flag) {
      state.clearscreen = flag
    },
    [types.SET_PPT_SIZE](state, payload) {
      state.pptSize = Object.assign({}, state.pptSize, payload)
    }
  },
  getters: {
    clearscreen: state => state.clearscreen,
    currentRoom (state, getters, rootState) {
      return rootState.roomInfo.roomDetail.data.room
    },
    pptSize: state => state.pptSize
  }
}
